import { render, staticRenderFns } from "./crearMaterial.vue?vue&type=template&id=f5f0b912"
import script from "./crearMaterial.vue?vue&type=script&lang=js"
export * from "./crearMaterial.vue?vue&type=script&lang=js"
import style0 from "./crearMaterial.vue?vue&type=style&index=0&id=f5f0b912&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports